import { useEffect, useState } from "react";
import {
  getCampaignById,
  getCampaignSummary
} from "../services/campaign.api";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";

export default function CampaignDetailScreen() {
const currentToken = useSelector((state)=>state?.user?.user?.token);
          const appToken = useSelector((state)=>state?.app?.app?.AppToken);
          
         const tenantId = useSelector((state)=>state?.user?.user?.user_id)

  const { id } = useParams();
  const [campaign, setCampaign] = useState(null);
  const [summary, setSummary] = useState(null);

  useEffect(() => {
    fetchData();
  }, []);

  async function fetchData() {
    const c = await getCampaignById(id,{currentToken,appToken,tenantId,});
    const s = await getCampaignSummary(id,{currentToken,appToken,tenantId,});

    setCampaign(c.data);
    setSummary(s.data);
  }

  if (!campaign || !summary) return <p>Loading...</p>;

  return (
    <div>
      <h2>{campaign.name}</h2>
      <p>Status: {campaign.status}</p>
      <p>Channel: {campaign.channel}</p>
      <p>Target: {campaign.targetType}</p>

      <hr />

      <h4>Summary</h4>
      <p>Total: {summary.total}</p>
      <p>Success: {summary.success}</p>
      <p>Failed: {summary.failed}</p>
      <p>Skipped: {summary.skipped_rate_limit + summary.skipped_user_disabled}</p>
    </div>
  );
}
